







































import Loader from '@/contexts/frontend/Loader.vue'

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String,
    userId: String
  },
  data: function() {
    return {
      user: {
        id: '',
        slug: '',
        name: ''
      },
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .GetUser(this.userId)
      .then(result => (this.user = result[0]))
      .finally(() => (this.loading = false))
  },
  methods: {
    deleteUser() {
      this.$api.clientAdmin
        .DeleteUser(this.user.id)
        .then(() => this.$router.push({ name: 'settings-users-list' }))
    }
  }
}
